// extracted by mini-css-extract-plugin
var _1 = "Input_default__p+FaO";
var _2 = "Input_fullWidth__9U+RK";
var _3 = "Input_input__dm9cz";
var _4 = "Input_inputError__lQpJ6";
var _5 = "Input_loginRegister__0PBi+";
export { _1 as "_default", _2 as "fullWidth", _3 as "input", _4 as "inputError", _5 as "loginRegister" }
